import { Boolean, Null, Number, Record, String } from 'runtypes';

export const PhoneCallListExtrasRunType = Record({
	callbackDesired: Boolean,
	callerName: String.Or(Null),
	callerNumber: String,
	duration: Number.Or(String),
	isAFax: Boolean,
	outgoingCallCallerName: String,
	receivedByCompleteName: String,
	receivedByInitial: String,
	receivedForCompleteName: String,
	receivedForInitial: String,
});
